import { DocumentInboxAssignment } from '../models/document.inbox.model';

const ENTITY_TYPE_LABEL_KEYS: Record<string, string> = {
  'quote': 'quote',
  'order': 'order',
  'invoice': 'invoice',
  'provider-order': 'providerOrder',
  'provider-invoice': 'providerInvoice',
  'expense': 'expense',
  'accounting-entry': 'accountingEntry',
  'delivery-note': 'deliveryNote',
}

const ENTITY_TYPE_ROUTES: Record<string, string> = {
  'quote': '/main/sale/quote/view/',
  'order': '/main/sale/order/view/',
  'invoice': '/main/sale/invoice/view/',
  'provider-order': '/main/purchase/order/view/',
  'provider-invoice': '/main/purchase/invoice/view/',
  'expense': '/main/purchase/expense/view/',
}

export function assignmentEntityLabel(labels: any, entityType: string): string {
  const key = ENTITY_TYPE_LABEL_KEYS[entityType]
  if (key && labels[key]) return labels[key]
  return entityType.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
}

export function assignmentEntityUrl(entityType: string, entityId: string): string | null {
  const base = ENTITY_TYPE_ROUTES[entityType]
  if (!base || !entityId) return null
  return base + entityId
}

export function assignmentDisplayReference(assignment: DocumentInboxAssignment): string {
  if (assignment.entity_number) return assignment.entity_number
  if (assignment.entity_id) return `#${assignment.entity_id.slice(-6).toUpperCase()}`
  return '-'
}
